export function capitalize(phrase: string): string {
    return phrase[0].toUpperCase() + phrase.slice(1);
}
